import {
    CalendarInterface,
    PeriodInterface
} from "../../../service/Business/Interfaces/CalendarInterface";
import FCTooltip from "../../FCObjets/FCTooltip";
import { useCalendarDayStyle } from "../../../hook/useCalendarDayStyle";
import { CalendarDayProps } from "../../../types/Calendar";

function CalendarDay(props: CalendarDayProps) {
    let text: string = "";
    if (props.date !== undefined) {
        text = props.date.getDate().toString();
        if (props.forceText !== undefined && props.forceText !== "") {
            text = props.forceText.toString();
        }
    }

    const dayStyle = useCalendarDayStyle(props);

    function eventClick(): void {
        if (dayStyle.style.cursor === "pointer" && dayStyle.dataPeriod) {
            props.onEventClick(dayStyle.dataPeriod);
        }
    }

    return (
        <div onClick={eventClick}>
            {(props.forceText &&
                    <div className={"day"} style={props.title ? {fontWeight: 700} : {}}>
                        {props.forceText}
                    </div>)
                ||
                (<div>
                    <div
                        style={!props.hide ? dayStyle.style : {border: "0px"}}
                        className={"tooltip day"}>
                        {props.hide ? "" : text}
                        {(dayStyle.tooltip1 || dayStyle.tooltip2) &&
                            <FCTooltip>
                                <div>{dayStyle.tooltip1}</div>
                                <div>{dayStyle.tooltip2}</div>
                            </FCTooltip>
                        }
                    </div>
                </div>)
            }
        </div>
    );
}

CalendarDay.defaultProps = {
    forceText: undefined,
    date: undefined,
    title: false,
    hide: false,
}

export default CalendarDay;